import { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import Button from "react-bootstrap/Button";
import axios from "axios";
import "../../styles.css";
import ReferralsTable from "./table";
import ReferralModal from "./modal";
import './style.scss'

const ReferralsList = () => {
  const perPage = 5;
  const { addToast } = useToasts();
  const [isBusy, setBusy] = useState(false);
  const [login, setLogin] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageItems, setPageItems] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortBy, setSortBy] = useState('pu.login');
  const [isRefresh, setRefresh] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [referrals, setReferrals] = useState([]);
  const [users, setUsers] = useState([]);
  const [isUpdateReferral, setUpdateReferral] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tableAction, setTableAction] = useState(null);
  const [editParams, setEditParams] = useState(null);
  const [orderBy, setOrderBy] = useState({
    header: "date_time", //pu_id, referral_id, percent, status, date_time, referral_id2, percent2, status2, date_time2
    order: "DESC", // ASC OR DESC
  });
  const [searchBy, setSearchBy] = useState('login-email')
  const [searchTrigger, setSearchTrigger] = useState(0)

  // useEffect(() => {
  //   if (login) setBusy(true);
  //   getReferrals();
  //   getReferralUsers();
  // }, [page, orderBy, sortBy, search, isRefresh, isUpdateReferral]);

  useEffect(() => {
    getReferrals();
    getReferralUsers();
  }, [searchTrigger]);

  const getReferrals = () => {
    setLoading(true)
    let payload = {
      page: page,
      per_page: perPage,
      login: login,
      header: orderBy.header,
      sort: sortBy,
      searchBy,
      order: orderBy.order
    }

    axios.get("/api/administration/referrals", {
      params: payload
    })
    .then((response) => {
      const data = response.data;
      setReferrals(data.referrals);
      setTotal(data.total);
      setPageItems(Math.ceil(data.total / perPage));
    })
    .catch((error) => {
      console.log(error.response)
    })
    .finally(() => {
      setBusy(false);
      setRefresh(false);
      setLoading(false);
      setUpdateReferral(false);
    });
  }

  const getReferralUsers = () => {
    /*axios.get("/api/administration/referral/users")
    .then((response) => {
      const data = response.data;
      setUsers(data.users);
    })
    .catch((error) => {
      console.log(error.response)
    })*/
  }


  const handleActionTable = (action, params={}) => {
    setTableAction(action)

    if(action == 'edit'){
      setEditParams(params);
    }else{
      setEditParams(null);
    }

    setShowModal(true);
  }

  const SearchPU = () => {
    const handleSearchByEmail = () => {
      setSearchBy('email')
      setOrderBy({
          header: "pu.email",
          order: "ASC", // ASC OR DESC
      })
      setSearchTrigger(searchTrigger=>searchTrigger+1)
    }
    const handleSearch = () => {
      setPage(1)
      setSearch(login)
      setSearchTrigger(searchTrigger => searchTrigger + 1)
    }
    const clearSearchText = () => {
      setLogin('');
    }
    return (
      <div className="my-2 mb-4">
        <div className="d-flex">
            <div className="mr-1 top-3">
                <input
                    type="text"
                    placeholder="Search User"
                    className="search-user-input"
                    onChange={(e) => setLogin(e.target.value)}
                    value={login}
                    disabled={isLoading}
                />
                {
                  login && <i className="fal fa-times search-clear-icon" onClick={clearSearchText} />
                }
            </div>

            <Button
                variant="primary"
                disabled={isLoading}
                onClick={handleSearch}
            >
                {isLoading ? "Searching..." : "Search Users"}
            </Button>
        </div>

        <div className="mt-1">
          <div className="form-check form-check-inline">
            <input
              name="searchBy"
              className="form-check-input"
              type="radio"
              id="searchByLoginEmail"
              value="login-email"
              onChange={() => setSearchBy('login-email')}
              checked={searchBy == 'login-email'}
            />
            <label className="form-check-label" htmlFor="searchByLogin">Login & Email</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              name="searchBy"
              className="form-check-input"
              type="radio"
              id="searchByLogin"
              value="login"
              onChange={() => setSearchBy('login')}
              checked={searchBy == 'login'}
            />
            <label className="form-check-label" htmlFor="searchByLogin">Login</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              name="searchBy"
              className="form-check-input"
              type="radio"
              id="searchByEmail"
              value="email"
              onChange={handleSearchByEmail}
              checked={searchBy == 'email'}
            />
            <label className="form-check-label" htmlFor="searchByEmail">Email</label>
          </div>
        </div>
    </div>
    );
  };

  return (
    <div className="referrals-list">
      <h3 className="mb-4">Referral + Commission %</h3>

      <div className="d-flex mb-3 flex-row align-items-center">
        {SearchPU()}

        {/* <div className="d-flex flex-row align-items-center px-3" onChange={(e) => setSortBy(e.target.value)}>
          <span className="mr-3">Sort by</span>
          <div className="form-check" style={{paddingLeft: 12, paddingRight: 12}}>
            <input className="form-check-input" style={{marginLeft: -15}} id="pu" type="radio" value="pu.login" checked={sortBy === 'pu.login'} />
            <label className="form-check-label" style={{paddingTop: 0.8}} htmlFor="pu">
              PU
            </label>
          </div>
          <div className="form-check" style={{paddingLeft: 12, paddingRight: 12}}>
            <input className="form-check-input" style={{marginLeft: -15}} id="ru" type="radio" value="ru.login" checked={sortBy === 'ru.login'} />
            <label className="form-check-label" style={{paddingTop: 0.8}} htmlFor="ru">
              RU
            </label>
          </div>
          <div className="form-check" style={{paddingLeft: 12, paddingRight: 12}}>
            <input className="form-check-input" style={{marginLeft: -15}} id="ru2" type="radio" value="ru2.login" checked={sortBy === 'ru2.login'} />
            <label className="form-check-label" style={{paddingTop: 0.8}} htmlFor="ru2">
              RU2
            </label>
          </div>
        </div> */}

        {/* <div>
          <Button
            variant="primary"
            disabled={isRefresh}
            onClick={() => setRefresh(!isRefresh)}>
            {isRefresh ? "Refreshing..." : "Refresh"}
          </Button>
        </div> */}
      </div>

      <ReferralsTable
        referrals={referrals}
        users={users}
        pageItems={pageItems}
        tableAction={tableAction}
        total={total}
        page={page}
        orderBy={orderBy}
        isLoading={isLoading}
        setPage={setPage}
        setOrderBy={setOrderBy}
        handleActionTable={handleActionTable}
        setTableAction={setTableAction}
        searchTrigger={searchTrigger}
        setSearchTrigger={setSearchTrigger}
      />

      <ReferralModal
        users={users}
        params={editParams}
        tableAction={tableAction}
        showModal={showModal}
        setShowModal={setShowModal}
        setUpdateReferral={setUpdateReferral}
        getReferrals={getReferrals}
        />
    </div>
  );
};

export default ReferralsList;
